module.exports = __webpack_public_path__ + "MindShapesPatternRed.png";